
















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IWitness } from "@/interfaces";

@Component({
  computed: {
    ...mapGetters("delegates", ["delegates"]),
  },
})
export default class DelegateCount extends Vue {
  private count = 0;
  private delegates: IWitness[];

  public mounted() {
    this.prepareComponent();
  }

  private prepareComponent() {
    this.getDelegateCount();

    this.$store.watch(
      (state) => state.delegates.delegatesCount,
      (value) => this.getDelegateCount(),
    );
  }

  private getDelegateCount() {
    this.count = this.$store.state.delegates.delegatesCount;
  }
}
